import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './fonts/Helvetica-Neue-Font/Helvetica Neue Medium Extended/Helvetica Neue Medium Extended.ttf';
import './fonts/Test desktop fonts (OTF)/Test Founders Grotesk Collection/Test Founders Grotesk/TestFoundersGrotesk-Regular.otf';
import './fonts/Test desktop fonts (OTF)/Test Founders Grotesk Collection/Test Founders Grotesk/TestFoundersGrotesk-Bold.otf';
import './fonts/Test desktop fonts (OTF)/Test Founders Grotesk Collection/Test Founders Grotesk Condensed/TestFoundersGroteskCondensed-Regular.otf';
import './fonts/Test desktop fonts (OTF)/Test Founders Grotesk Collection/Test Founders Grotesk Mono/TestFoundersGroteskMono-Regular.otf';
import './fonts/Test desktop fonts (OTF)/Test Founders Grotesk Collection/Test Founders Grotesk Text/TestFoundersGroteskText-Regular.otf';
import './fonts/Test desktop fonts (OTF)/Test Geograph/TestGeograph-Regular.otf';
import './fonts/Labil Grotesk/LabilGrotesk-Bold.ttf';
import './fonts/Labil Grotesk/LabilGrotesk-Light.ttf';
import './fonts/Labil Grotesk/LabilGrotesk-Medium.ttf';
import './fonts/Labil Grotesk/LabilGrotesk-Regular.ttf';
import './fonts/Labil Grotesk/LabilGrotesk-Thin.ttf';



ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
